import * as React from "react"
import { $isAtNodeEnd } from "@lexical/selection"
import { ElementNode, RangeSelection } from "lexical"
import RgptParagraphNode from "../CustomNodes/ParagraphNode"
import { $createHeadingNode } from "@lexical/rich-text"
import {
  AlignHorizontalCenter,
  AlignHorizontalLeft,
  AlignHorizontalRight,
  FormatBold,
  FormatItalic,
  FormatStrikethrough,
  FormatUnderlined,
} from "@mui/icons-material"

export type BlockType = "root" | "rgpt-paragraph" | "h2" | "h1" | "ul" | "ol"

export type TextFormat = "bold" | "italic" | "underline" | "strikethrough"

export type TextAlignment = "left" | "center" | "right"

export const BlockTypeMapping = {
  root: "Normal",
  "rgpt-paragraph": "Normal",
  paragraph: "Normal",
  h2: "Small Heading",
  h1: "Large Heading",
  ol: "Number List",
  ul: "Bullet List",
} as const

export const BlockTypeConstructorMapping: Partial<Record<BlockType, () => ElementNode>> = {
  "rgpt-paragraph": () => new RgptParagraphNode(),
  h1: () => $createHeadingNode("h1"),
  h2: () => $createHeadingNode("h2"),
}

export const getBlockTypeOption = (blockType: BlockType) => ({ value: blockType, label: BlockTypeMapping[blockType] })

export const BlockTypeOptions = [
  { value: "rgpt-paragraph", label: "Normal" },
  { value: "h2", label: "Small Heading" },
  { value: "h1", label: "Large Heading" },
  { value: "ol", label: "Number List" },
  { value: "ul", label: "Bullet List" },
] as const

export const TextFormatOptions = [
  { tooltipText: "Bold", value: "bold", icon: <FormatBold /> },
  { tooltipText: "Italic", value: "italic", icon: <FormatItalic /> },
  { tooltipText: "Underline", value: "underline", icon: <FormatUnderlined /> },
  { tooltipText: "Strike Through", value: "strikethrough", icon: <FormatStrikethrough /> },
] as const

export const TextAlignmentOptions = [
  { tooltipText: "Align Left", value: "left", icon: <AlignHorizontalLeft /> },
  { tooltipText: "Align Center", value: "center", icon: <AlignHorizontalCenter /> },
  { tooltipText: "Align Right", value: "right", icon: <AlignHorizontalRight /> },
] as const

// Copied from lexical sandbox
export const getSelectedNode = (selection: RangeSelection) => {
  const anchor = selection.anchor
  const focus = selection.focus
  const anchorNode = selection.anchor.getNode()
  const focusNode = selection.focus.getNode()

  if (anchorNode === focusNode) {
    return anchorNode
  }

  const isBackward = selection.isBackward()

  if (isBackward) {
    return $isAtNodeEnd(focus) ? anchorNode : focusNode
  } else {
    return $isAtNodeEnd(anchor) ? focusNode : anchorNode
  }
}

export const toggleEditedLinkVisibility = ({ element, visible }: { element: HTMLElement; visible: boolean }) => {
  element.style.position = visible ? "relative" : "absolute"
  element.style.opacity = visible ? "1" : "0"
}
